import { render, staticRenderFns } from "./CompanionViewAllHeader.vue?vue&type=template&id=5271a308&scoped=true&lang=pug&"
import script from "./CompanionViewAllHeader.vue?vue&type=script&lang=js&"
export * from "./CompanionViewAllHeader.vue?vue&type=script&lang=js&"
import style0 from "./CompanionViewAllHeader.vue?vue&type=style&index=0&id=5271a308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5271a308",
  null
  
)

export default component.exports